import { Checkbox, CheckboxProps } from '../../Checkbox';
import { FormFieldProps } from '../types';
import { splitProps } from '@/utils';
import { Field, useField } from '../Field';
import { ChangeEvent, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export const CheckboxComponent = (props: CheckboxProps) => {
  const field = useField();
  const { setValue } = useFormContext();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      setValue(field.name, value, { shouldDirty: true, shouldValidate: true });
    },
    [setValue, field.name],
  );

  return <Checkbox {...{ ...props, ...field, onChange: handleChange }} />;
};

export const CheckboxField = (fieldProps: FormFieldProps<Omit<CheckboxProps, 'value'>>) => {
  const restProps = splitProps(fieldProps, [
    'className',
    'disabled',
    'tooltipText',
  ]) as CheckboxProps;

  return (
    <Field {...{ ...fieldProps, includeError: false }}>
      <CheckboxComponent {...restProps} />
    </Field>
  );
};
